module.exports = __webpack_public_path__ + "img/inactivity.5014bf2f.jpg";